import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { Events } from '@df/core/service/event';
import { Status } from '@df/core/status';
import { Subscription } from 'rxjs';
import { CheckoutFormComponent } from '../form/checkout-form.component';

import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { IfApplePayAvailableDirective } from '@df/module-apple-pay/if-apple-pay-available.directive';
import { GtmService } from '@df/module-gtm/gtm.service';
import { ImageModule } from '@df/module-image/image.module';
import { Customer } from '@df/session/api/customer';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { BasketViewTotalsComponent } from '../../basket/view-totals/basket-view-totals.component';
import { AdyenApplePayComponent } from '../../module/adyen/apple-pay/adyen-apple-pay.component';
import { AdyenGooglePayComponent } from '../../module/adyen/google-pay/adyen-google-pay.component';
import { BarclaycardApplePayComponent } from '../../module/barclaycard-cybersource/apple-pay/barclaycard-apple-pay.component';
import { BarclaycardGooglePayComponent } from '../../module/barclaycard-cybersource/google-pay/barclaycard-google-pay.component';
import { GTM_FORM_FIELD_ERROR_MESSAGE, LocalGtmService } from '../../module/gtm/gtm.service.decorator';
import { PaypalPayInThreeMessageComponent } from '../../module/paypal-pay-in-three/paypal-pay-in-three-message.component';
import { NewsletterCheckboxesComponent } from '../../newsletter/newsletter-checkboxes.component';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/api/result.component';
import { CheckoutStepComponent } from './../step/checkout-step.component';
export const CHECKOUT_SUBMIT_CLICK_EVENT_NAME = 'checkout.submit-button.click';

@Component({
    selector: 'checkout-submit',
    templateUrl: './checkout-submit.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        TranslationModule,
        ResultComponent,
        forwardRef(() =>BasketViewTotalsComponent),
        ActionComponent,
        NewsletterCheckboxesComponent,
        AdyenGooglePayComponent,
        BarclaycardGooglePayComponent,
        AdyenApplePayComponent,
        BarclaycardApplePayComponent,
        ResultComponent,
        BarclaycardApplePayComponent,
        AdyenApplePayComponent,
        BarclaycardGooglePayComponent,
        AdyenGooglePayComponent,
        RouterLink,
        IfApplePayAvailableDirective,
        PaypalPayInThreeMessageComponent,
        ImageModule
    ]
})
export class CheckoutSubmitComponent implements OnInit, OnDestroy {
    // we use input for detect changes purposes
    @Input()
    paymentMethodCode?: string | number;

    private formErrorSend = false;

    private subscriptions = new Subscription();

    constructor(
        public checkoutFormComponent: CheckoutFormComponent,
        private checkoutStepComponent: CheckoutStepComponent,
        private changeDetectorRef: ChangeDetectorRef,
        private events: Events,
        private readonly gtmService: GtmService,
        protected customer: Customer
    ) {}

    ngOnInit(): void {
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.checkoutFormComponent.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.checkoutFormComponent.savePaymentMethodStatus.subscribe(() => this.detectChanges()));
        this.subscriptions.add(
            this.status.subscribe(() => {
                if (this.status.data.error) {
                    this.gtmService.sendEventGA4('error_tracking', {
                        error_type: 'submit',
                        form: 'Payment',
                        form_step: '3',
                        error_message: this.status.error,
                        coupon: this.customer.basket.data.coupon
                    });
                }
            })
        );
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    get status(): Status {
        return this.checkoutFormComponent.status;
    }
    get isSamples(): boolean {
        return this.checkoutFormComponent.isSamples;
    }
    get email(): string | undefined {
        return this.checkoutFormComponent.email;
    }
    submit(): void {
        this.checkoutStepComponent.markSubmitted(true);
        if (this.checkoutStepComponent.valid) {
            this.events.broadcast(CHECKOUT_SUBMIT_CLICK_EVENT_NAME);
            this.checkoutFormComponent.isSamples &&
                (this.checkoutFormComponent.data.address.billing = this.checkoutFormComponent.data.address.shipping);
            return this.checkoutFormComponent.submit();
        } else if (!this.formErrorSend) {
            this.formErrorSend = true;
            (this.gtmService as LocalGtmService).sendFormError(
                GTM_FORM_FIELD_ERROR_MESSAGE,
                'checkout ' + this.checkoutStepComponent.name,
                3
            );
        }
    }
    isPaymentMethodAvailable(code: string | number): boolean {
        return !!this.checkoutFormComponent.paymentMethodByCode(code);
    }
    private detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }

    get paymentMethodCodeAsString(): string {
        return this.paymentMethodCode as string;
    }
}
